import { Controller } from "@hotwired/stimulus"

// Máscara de moeda brasileira: R$ 1.234,56
// O valor real (float) é mantido em um hidden field para envio ao server
export default class extends Controller {
  static targets = ["display", "value"]

  connect() {
    this.displayTarget.addEventListener("input", this.format.bind(this))
    this.displayTarget.addEventListener("keydown", this.preventInvalid.bind(this))

    // Se já tem valor, formata
    if (this.valueTarget.value) {
      const cents = Math.round(parseFloat(this.valueTarget.value) * 100)
      if (cents > 0) this.displayTarget.value = this.formatCents(cents)
    }
  }

  preventInvalid(e) {
    // Permite: backspace, delete, tab, escape, enter, arrows
    if ([8, 9, 27, 13, 46, 37, 38, 39, 40].includes(e.keyCode)) return
    // Permite: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].includes(e.keyCode)) return
    // Bloqueia tudo que não é número
    if (e.key < "0" || e.key > "9") e.preventDefault()
  }

  format() {
    let raw = this.displayTarget.value.replace(/\D/g, "")
    if (raw === "") {
      this.valueTarget.value = ""
      this.displayTarget.value = ""
      return
    }

    let cents = parseInt(raw, 10)
    this.valueTarget.value = (cents / 100).toFixed(2)
    this.displayTarget.value = this.formatCents(cents)
  }

  formatCents(cents) {
    const reais = Math.floor(cents / 100)
    const centavos = (cents % 100).toString().padStart(2, "0")
    const reaisFormatted = reais.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    return `${reaisFormatted},${centavos}`
  }
}
